// ui/ModalPortal.js
import { createPortal } from "react-dom";

export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return null;   // SSR-safe
  return createPortal(children, document.body);
}
